import PropTypes from 'prop-types';
import { availability } from '../../components/common/Availability/Availability.proptypes';

export const product = {
  availability,
  brand: PropTypes.string,
  category: PropTypes.string,
  checkFitment: PropTypes.string,
  classification: PropTypes.string,
  kitId: PropTypes.string,
  name: PropTypes.string,
  packageFlag: PropTypes.string,
  partNumber: PropTypes.string,
  position: PropTypes.number,
  price: PropTypes.string,
  productWeight: PropTypes.string,
  relatedModel: PropTypes.string
};

export const productShape = PropTypes.shape(product);
